// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const SingleUnionTypeProperties = {
    samePropertiesAsObject: (value) => {
        return Object.assign(Object.assign({}, value), { propertiesType: "samePropertiesAsObject", _visit: function (visitor) {
                return FernIr.SingleUnionTypeProperties._visit(this, visitor);
            } });
    },
    singleProperty: (value) => {
        return Object.assign(Object.assign({}, value), { propertiesType: "singleProperty", _visit: function (visitor) {
                return FernIr.SingleUnionTypeProperties._visit(this, visitor);
            } });
    },
    noProperties: () => {
        return {
            propertiesType: "noProperties",
            _visit: function (visitor) {
                return FernIr.SingleUnionTypeProperties._visit(this, visitor);
            },
        };
    },
    _visit: (value, visitor) => {
        switch (value.propertiesType) {
            case "samePropertiesAsObject":
                return visitor.samePropertiesAsObject(value);
            case "singleProperty":
                return visitor.singleProperty(value);
            case "noProperties":
                return visitor.noProperties();
            default:
                return visitor._other(value);
        }
    },
};
